import styled from '@emotion/styled';

import {FilterOverlayTrigger} from '@/components/FilterOverlayTrigger';

export const FilterTrigger = styled(FilterOverlayTrigger)`
  padding: 0;
  border: none;
  display: flex;
  white-space: nowrap;
`;
